module.exports = __webpack_public_path__ + "static/media/paintFigure.89d9c282.jpg";